export const COUNT_LIMIT = {
  STORY_NAME: 40,
  STORY_DESCRIPTION: 150,
  TAG: 10,
  CHARACTER_NAME: 15,
  CHARACTER_STATUS: 200,
  EPISODE_NAME: 40,
  NARRATION_TEXT: 10000,
  POST_CONTENT: 500,
  DIALOGUE: 10000,
  COMMENT: 500,
  SUGGEST_CONTENT_LENGTH: 1000,
  MAX_LIMIT: 10000000,
  COMMUNITY_COMMENT: 1000,
  BUBBLE_CHAT_TAG: 5,
  BUBBLE_CHAT_LIST_LIMIT: 24,
  BUBBLE_CHAT_ASSET_COMMENT: 3000,
  CHARACTER_INPUT: {
    NAME: 25,
    INTRODUCTION: 500,
    TAG: 5,
    JOB: 20,
    AGE: 1000000000,
    PERSONALITY: 100,
    SPEAKING_STYLE: 100,
    FAVORITES: 100,
    PROMPT: 20000,
    UNIFIED_PROMPT: 50000,
    /**
     * 상세 설명(유저 전용 / AI 미전달) 글자수 상한.
     * 프롬프트 카운터와 분리된 별도 상한이다 — AI에 전달되지 않아 토큰 비용과 무관하다.
     * 시안 상태 S2에 "상한 10,000자 확정"으로 명시돼 있다(#2036).
     */
    DETAIL_DESCRIPTION: 10000,
    /**
     * 통합형 상세 설명 상한 — 조합형(10,000자)과 달리 공개 인물·배경 두 칸(각 10,000자대)이
     * 하나로 합쳐 이관되기 때문에 서버 상한이 20,002자다(#2036 백엔드 QA).
     */
    UNIFIED_DETAIL_DESCRIPTION: 20002,
    FIRST_MESSAGES: 2000,
    TRIGGER_IMAGES: {
      MIN_UNLOCK_PRICE: 100,
      MAX_UNLOCK_PRICE: 100_000_000,
      TRIGGER_WORDS: 50,
      NAME: 20,
      // 캐릭터당 보유 가능한 총 장수
      MAX_COUNT: 200,
      // 1회 드롭/선택으로 올릴 수 있는 장수. 현재는 MAX_COUNT와 같아 빈 캐릭터를 한 번에
      // 채울 수 있다. 서버 부하 등으로 1회 상한만 낮춰야 할 수 있어 별도 상수로 둔다.
      // 200장이면 동시성 4 기준 업로드가 3분가량 이어져, 인앱 웹뷰에서 백그라운드 전환으로
      // 프로세스가 회수될 창이 그만큼 길어진다. 문제가 되면 이 값만 100으로 되돌린다.
      BULK_UPLOAD_MAX: 200,
      // 1회 업로드 시 동시에 처리할 이미지 개수.
      // 병목은 브라우저 커넥션이 아니라 메인 스레드 canvas 인코딩과 서버 post-process(blur 파생본 생성)다.
      UPLOAD_CONCURRENCY: 4,
      // 항목당 자동 재시도 횟수 (429/5xx/네트워크 에러만 대상)
      UPLOAD_RETRY: 2,
    },
    KEYWORD_BOOKS: {
      CONTENTS: 500,
    },
    CREATOR_COMMENT: 2000,
    WORD_BOOKS_TITLE: 25,
    WORD_BOOKS: 10000,
    /** 설정집 AI 칸 상한 — 서버와 동일(공개 칸은 WORD_BOOKS). 두 칸은 합산하지 않는다. */
    WORD_BOOKS_AI: 10001,
    OPENINGS: {
      MAX_COUNT: 3,
      TITLE: 25,
      CONTENT: 2000,
    },
  },
  UNIVERSE_INPUT: {
    NAME: 25,
    INTRODUCTION: 500,
    TAG: 5,
    WORD_BOOKS_TITLE: 25,
    WORD_BOOKS: 10000,
    /** 설정집 AI 칸 상한 — 서버와 동일(공개 칸은 WORD_BOOKS). 두 칸은 합산하지 않는다. */
    WORD_BOOKS_AI: 10001,
    PROMPT: 20000,
    CREATOR_COMMENT: 2000,
  },
  SCENE_INPUT: {
    NAME: 25,
    INTRODUCTION: 500,
    TAG: 5,
    PLACE: 100,
    TIME: 100,
    PROMPT: 10000,
    CREATOR_COMMENT: 2000,
  },
  CHAT_EDIT_USER_MESSAGE_INPUT: 2000,
  CHAT_EDIT_CHARACTER_MESSAGE_INPUT: 5000,
  PASSWORD: {
    MIN: 8,
    MAX: 25,
  },
  SEARCH_VALUE_LENGTH_LIMIT: 40,
  USERNOTE: 10000,
  USER_PERSONA_DETAIL: 5000,
};
